<template>
  <div class="relative">
    <VueLoading :active.sync="loading" :is-full-page="false" />
    <StatCard
      title="Costs"
      :value="formatCurrency(currentCost)"
      :change="changePercentage"
      :isPositive="changePercentage <= 0"
      customClass="costs-stat-card"
    />
  </div>
</template>

<script>
import StatCard from './StatCard.vue'
import HTTP from '@/common/http'
import { mapGetters } from 'vuex'
import VueLoading from 'vue-loading-overlay'

export default {
  name: 'CostsStatCard',
  components: {
    StatCard,
    VueLoading
  },
  props: {
    id: {
      type: String,
      default: 'AllContracts'
    },
    currency: {
      type: String,
      default: '$'
    }
  },
  data () {
    return {
      loading: false,
      currentCost: 0,
      changePercentage: 0
    }
  },
  computed: {
    ...mapGetters(['activeType'])
  },
  methods: {
    formatCurrency (value) {
      return `${this.currency}${Number(value).toFixed(2)}`
    },
    fetchCosts () {
      this.loading = true

      HTTP.get(`costs/summary/${this.activeType}/${this.id}`)
        .then(response => {
          const costsData = response && response.data && response.data.costs ? response.data.costs : {}

          // Determine current and previous month keys
          const now = new Date()
          const monthMap = {
            0: 'Jan',
            1: 'Feb',
            2: 'Mar',
            3: 'Apr',
            4: 'May',
            5: 'Jun',
            6: 'Jul',
            7: 'Aug',
            8: 'Sep',
            9: 'Oct',
            10: 'Nov',
            11: 'Dec'
          }
          const currentMonth = monthMap[now.getMonth()]
          const previousMonth = now.getMonth() > 0 ? monthMap[now.getMonth() - 1] : null

          let current = []
          let previous = []

          const allAccounts = Object.values(costsData)

          for (let i = 0; i < allAccounts.length; i++) {
            const accountMonths = allAccounts[i]

            if (
              accountMonths &&
              accountMonths[currentMonth] &&
              Array.isArray(accountMonths[currentMonth])
            ) {
              current = current.concat(accountMonths[currentMonth])
            }

            if (
              previousMonth &&
              accountMonths &&
              accountMonths[previousMonth] &&
              Array.isArray(accountMonths[previousMonth])
            ) {
              previous = previous.concat(accountMonths[previousMonth])
            }
          }

          const latestSum = current.reduce((acc, item) => acc + (item.amount || 0), 0)
          const previousSum = previous.reduce((acc, item) => acc + (item.amount || 0), 0)

          this.currentCost = latestSum
          this.changePercentage = previousSum !== 0
            ? (((latestSum - previousSum) / previousSum) * 100).toFixed(2)
            : 0
        })
        .catch(error => {
          console.error('Failed to fetch costs:', error.message)
          this.currentCost = 0
          this.changePercentage = 0
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    id: {
      immediate: true,
      handler () {
        this.fetchCosts()
      }
    }
  }
}
</script>

<style scoped>
.costs-stat-card {
  border-left: 4px solid #8b5cf6; /* Purple tone for costs */
}
</style>



// WEBPACK FOOTER //
// src/components/Cards/StatCards/CostsStatCard.vue